// import React, { useState } from 'react';
// import { motion } from 'framer-motion';
// import styled from 'styled-components';
// import { History, Zap } from 'lucide-react';

// const DifferenceSection = () => {
//     const [hoveredIndex, setHoveredIndex] = useState(null);

//     const comparisonData = [
//         { trad: "Vacancy-focused hiring", merida: "Workforce transformation consulting" },
//         { trad: "Resume-forward sourcing", merida: "Strategic talent alignment" },
//         { trad: "Generic recruitment support", merida: "Industry-specialized workforce expertise" },
//         { trad: "Fragmented HR services", merida: "Integrated workforce ecosystem" },
//         { trad: "Manual recruitment execution", merida: "AI-assisted recruitment operations" },
//         { trad: "Short-term staffing support", merida: "Long-term workforce scalability" },
//         { trad: "Hiring-focused engagement", merida: "Operational workforce consulting" },
//         { trad: "Reactive HR processes", merida: "Structured workforce systems" },
//         { trad: "Limited visibility", merida: "Workforce intelligence & planning" },
//     ];

//     // Coordinate mapping parameters for 1200x700 viewport
//     const cx = 600;
//     const cy = 350;
//     const rx = 180;
//     const leftPillX = 320;
//     const rightPillX = 880;

//     const startY = 80;
//     const endY = 620;
//     const midY1 = 200;
//     const midY2 = 500;

//     // Generate row node coordinates dynamically along the hexagonal track
//     const nodes = Array.from({ length: 9 }).map((_, i) => {
//         const y = 60 + i * 72.5;
//         let dx = 0;
//         if (y > startY && y < midY1) {
//             dx = rx * ((y - startY) / (midY1 - startY));
//         } else if (y >= midY1 && y <= midY2) {
//             dx = rx;
//         } else if (y > midY2 && y < endY) {
//             dx = rx * ((endY - y) / (endY - midY2));
//         } else {
//             dx = 0;
//         }
//         const xLeft = cx - dx;
//         const xRight = cx + dx;
//         return { y, xLeft, xRight };
//     });

//     return (
//         <SectionContainer>
//             <div className="container mx-auto px-6 relative z-10">

//                 {/* --- HEADER --- */}
//                 <div className="text-center mb-16 max-w-3xl mx-auto">
//                     <motion.h2 
//                         initial={{ opacity: 0, y: 20 }}
//                         whileInView={{ opacity: 1, y: 0 }}
//                         className="text-3xl md:text-5xl font-bold text-white syne leading-tight mb-6"
//                     >
//                         Strategic <span className="text-blue-500 italic">Evolution</span>
//                     </motion.h2>
//                     <motion.p
//                         initial={{ opacity: 0, y: 20 }}
//                         whileInView={{ opacity: 1, y: 0 }}
//                         transition={{ delay: 0.2, duration: 0.6 }}
//                         className="text-slate-300 text-sm md:text-base leading-relaxed font-normal"
//                     >
//                         Empowering organizations to adapt, innovate, and thrive in a changing business landscape through forward-thinking strategies, workforce transformation, and continuous improvement initiatives.
//                     </motion.p>
//                 </div>

//                 {/* --- DESKTOP CHART VIEW --- */}
//                 <div className="hidden lg:block max-w-6xl mx-auto h-[700px] relative">

//                     {/* Inline SVG rendering divider, arcs, and connection lines */}
//                     <svg className="absolute inset-0 w-full h-full pointer-events-none z-0" viewBox="0 0 1200 700" fill="none" xmlns="http://www.w3.org/2000/svg">
//                         {/* Central Divider */}
//                         <motion.line 
//                             x1="600" y1="50" x2="600" y2="650" 
//                             stroke="rgba(255,255,255,0.06)" strokeWidth="1" strokeDasharray="4 4" 
//                             initial={{ pathLength: 0 }}
//                             whileInView={{ pathLength: 1 }}
//                             viewport={{ once: true }}
//                             transition={{ duration: 1, ease: "easeInOut" }}
//                         />

//                         {/* Hexagon Left track */}
//                         <motion.path 
//                             d="M 600,80 L 420,200 L 420,500 L 600,620" 
//                             stroke="rgba(255,255,255,0.12)" strokeDasharray="6 4" fill="none" strokeWidth="1.5" 
//                             initial={{ pathLength: 0 }}
//                             whileInView={{ pathLength: 1 }}
//                             viewport={{ once: true }}
//                             transition={{ duration: 1.5, ease: "easeInOut", delay: 0.2 }}
//                         />
//                         {/* Hexagon Right track */}
//                         <motion.path 
//                             d="M 600,80 L 780,200 L 780,500 L 600,620" 
//                             stroke="rgba(255,255,255,0.12)" strokeDasharray="6 4" fill="none" strokeWidth="1.5" 
//                             initial={{ pathLength: 0 }}
//                             whileInView={{ pathLength: 1 }}
//                             viewport={{ once: true }}
//                             transition={{ duration: 1.5, ease: "easeInOut", delay: 0.2 }}
//                         />

//                         {/* Center Labels */}
//                         <motion.text 
//                             x="565" y="357" textAnchor="end" 
//                             className="text-base font-bold fill-slate-400 tracking-wider font-sans"
//                             initial={{ opacity: 0 }}
//                             whileInView={{ opacity: 1 }}
//                             viewport={{ once: true }}
//                             transition={{ duration: 0.8, delay: 0.4 }}
//                         >
//                             Traditional
//                         </motion.text>
//                         <motion.text 
//                             x="635" y="357" textAnchor="start" 
//                             className="text-base font-bold fill-blue-400 tracking-wider font-sans"
//                             initial={{ opacity: 0 }}
//                             whileInView={{ opacity: 1 }}
//                             viewport={{ once: true }}
//                             transition={{ duration: 0.8, delay: 0.4 }}
//                         >
//                             Merida
//                         </motion.text>

//                         {/* Connector Lines & Arcs */}
//                         {nodes.map((node, i) => {
//                             const isHovered = hoveredIndex === i;
//                             return (
//                                 <g key={i}>
//                                     {/* Left Line */}
//                                     <motion.line 
//                                         x1={node.xLeft} 
//                                         y1={node.y} 
//                                         x2={leftPillX} 
//                                         y2={node.y} 
//                                         stroke={isHovered ? '#06b6d4' : 'rgba(255,255,255,0.1)'} 
//                                         strokeWidth={isHovered ? 2.5 : 1}
//                                         initial={{ pathLength: 0 }}
//                                         whileInView={{ pathLength: 1 }}
//                                         viewport={{ once: true }}
//                                         transition={{ duration: 0.6, ease: "easeOut", delay: 0.3 + i * 0.04 }}
//                                         className="transition-all duration-300"
//                                     />
//                                     {/* Right Line */}
//                                     <motion.line 
//                                         x1={node.xRight} 
//                                         y1={node.y} 
//                                         x2={rightPillX} 
//                                         y2={node.y} 
//                                         stroke={isHovered ? '#3b82f6' : 'rgba(255,255,255,0.1)'} 
//                                         strokeWidth={isHovered ? 2.5 : 1}
//                                         initial={{ pathLength: 0 }}
//                                         whileInView={{ pathLength: 1 }}
//                                         viewport={{ once: true }}
//                                         transition={{ duration: 0.6, ease: "easeOut", delay: 0.3 + i * 0.04 }}
//                                         className="transition-all duration-300"
//                                     />
//                                     {/* Left Arc Node */}
//                                     <motion.circle 
//                                         cx={node.xLeft} 
//                                         cy={node.y} 
//                                         r={isHovered ? 6 : 4} 
//                                         fill={isHovered ? '#06b6d4' : '#01014C'} 
//                                         stroke={isHovered ? '#fff' : 'rgba(255,255,255,0.3)'} 
//                                         strokeWidth={1.5}
//                                         initial={{ scale: 0 }}
//                                         whileInView={{ scale: 1 }}
//                                         viewport={{ once: true }}
//                                         transition={{ type: "spring", stiffness: 200, delay: 0.4 + i * 0.04 }}
//                                         className="transition-all duration-300"
//                                     />
//                                     {/* Right Arc Node */}
//                                     <motion.circle 
//                                         cx={node.xRight} 
//                                         cy={node.y} 
//                                         r={isHovered ? 6 : 4} 
//                                         fill={isHovered ? '#3b82f6' : '#01014C'} 
//                                         stroke={isHovered ? '#fff' : 'rgba(255,255,255,0.3)'} 
//                                         strokeWidth={1.5}
//                                         initial={{ scale: 0 }}
//                                         whileInView={{ scale: 1 }}
//                                         viewport={{ once: true }}
//                                         transition={{ type: "spring", stiffness: 200, delay: 0.4 + i * 0.04 }}
//                                         className="transition-all duration-300"
//                                     />
//                                 </g>
//                             );
//                         })}
//                     </svg>

//                     {/* Left Pillars (Traditional) */}
//                     {nodes.map((node, i) => (
//                         <motion.div 
//                             key={`left-${i}`}
//                             style={{ top: `${node.y - 24}px`, left: '0px', width: `${leftPillX}px` }}
//                             initial={{ opacity: 0, x: -35 }}
//                             whileInView={{ opacity: 1, x: 0 }}
//                             viewport={{ once: true }}
//                             transition={{ duration: 0.6, ease: "easeOut", delay: 0.6 + i * 0.05 }}
//                             className="absolute flex items-center justify-end h-[48px]"
//                         >
//                             <PillButton 
//                                 onMouseEnter={() => setHoveredIndex(i)}
//                                 onMouseLeave={() => setHoveredIndex(null)}
//                                 className={`text-right w-[290px] justify-end ${
//                                     i % 2 === 0 
//                                         ? 'bg-[#0f766e]/20 border-[#0f766e]/30 text-slate-300' 
//                                         : 'bg-[#115e59]/30 border-[#115e59]/40 text-slate-300'
//                                 } ${hoveredIndex === i ? 'opacity-40 scale-[0.98] border-transparent' : ''}`}
//                             >
//                                 <span className="text-xs md:text-[14px]">{comparisonData[i].trad}</span>
//                             </PillButton>
//                         </motion.div>
//                     ))}

//                     {/* Right Pillars (Merida Advantage) */}
//                     {nodes.map((node, i) => (
//                         <motion.div 
//                             key={`right-${i}`}
//                             style={{ top: `${node.y - 24}px`, right: '0px', width: `${1200 - rightPillX}px` }}
//                             initial={{ opacity: 0, x: 35 }}
//                             whileInView={{ opacity: 1, x: 0 }}
//                             viewport={{ once: true }}
//                             transition={{ duration: 0.6, ease: "easeOut", delay: 0.6 + i * 0.05 }}
//                             className="absolute flex items-center justify-start h-[48px]"
//                         >
//                             <PillButton 
//                                 onMouseEnter={() => setHoveredIndex(i)}
//                                 onMouseLeave={() => setHoveredIndex(null)}
//                                 className={`text-left w-[290px] justify-start ${
//                                     i % 2 === 0 
//                                         ? 'bg-[#0d9488]/20 border-[#0d9488]/30 text-white' 
//                                         : 'bg-[#0f766e]/35 border-[#0f766e]/40 text-white'
//                                 } ${
//                                     hoveredIndex === i 
//                                         ? 'active-highlight scale-[1.03] border-cyan-400 shadow-[0_0_20px_rgba(34,211,238,0.25)] z-10' 
//                                         : ''
//                                 }`}
//                             >
//                                 <span className="text-xs md:text-[14px] font-semibold">{comparisonData[i].merida}</span>
//                             </PillButton>
//                         </motion.div>
//                     ))}

//                 </div>

//                 {/* --- RESPONSIVE MOBILE VIEW --- */}
//                 <div className="block lg:hidden max-w-md mx-auto space-y-6">
//                     <div className="grid grid-cols-2 mb-4 border-b border-white/10 pb-2">
//                         <div className="flex items-center gap-1.5 text-slate-500">
//                             <History size={14} />
//                             <span className="text-[9px] font-black uppercase tracking-[0.2em]">Traditional</span>
//                         </div>
//                         <div className="flex items-center gap-1.5 justify-end text-blue-400">
//                             <span className="text-[9px] font-black uppercase tracking-[0.2em]">Merida</span>
//                             <Zap size={14} fill="currentColor" />
//                         </div>
//                     </div>
//                     {comparisonData.map((item, i) => (
//                         <div key={i} className="bg-[#02023b] border border-blue-900/40 p-4 rounded-2xl space-y-2 shadow-lg">
//                             <div className="flex items-start gap-2">
//                                 <span className="text-slate-500 text-xs mt-0.5">✗</span>
//                                 <p className="text-xs text-slate-400 leading-tight">{item.trad}</p>
//                             </div>
//                             <div className="flex items-start gap-2 border-t border-white/5 pt-2">
//                                 <span className="text-cyan-400 text-xs mt-0.5">✓</span>
//                                 <p className="text-xs md:text-sm font-semibold text-white leading-tight">{item.merida}</p>
//                             </div>
//                         </div>
//                     ))}
//                 </div>

//             </div>
//         </SectionContainer>
//     );
// };

// const SectionContainer = styled.section`
//     background-color: #01014C;
//     padding: 120px 0;
//     overflow: hidden;
//     position: relative;
// `;

// const PillButton = styled.div`
//     padding: 10px 24px;
//     border: 1px solid;
//     border-radius: 99rem;
//     display: inline-flex;
//     align-items: center;
//     transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
//     cursor: pointer;

//     &.active-highlight {
//         background: linear-gradient(135deg, #0d9488 0%, #06b6d4 100%) !important;
//         border-color: #22d3ee !important;
//     }
// `;

// export default DifferenceSection;










// import React, { useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import styled from 'styled-components';
// import { History, Zap, ArrowRight } from 'lucide-react';

// const DifferenceSection = () => {
//     const [hoveredIndex, setHoveredIndex] = useState(null);

//     const comparisonData = [
//         { trad: "Vacancy-focused hiring", merida: "Workforce transformation consulting" },
//         { trad: "Resume-forward sourcing", merida: "Strategic talent alignment" },
//         { trad: "Generic recruitment support", merida: "Industry-specialized workforce expertise" },
//         { trad: "Fragmented HR services", merida: "Integrated workforce ecosystem" },
//         { trad: "Manual recruitment execution", merida: "AI-assisted recruitment operations" },
//         { trad: "Short-term staffing support", merida: "Long-term workforce scalability" },
//         { trad: "Hiring-focused engagement", merida: "Operational workforce consulting" },
//         { trad: "Reactive HR processes", merida: "Structured workforce systems" },
//         { trad: "Limited visibility", merida: "Workforce intelligence & planning" },
//     ];

//     // Animation Variants
//     const containerVariants = {
//         hidden: { opacity: 0 },
//         visible: {
//             opacity: 1,
//             transition: { staggerChildren: 0.1 }
//         }
//     };

//     const leftItemVariants = {
//         hidden: { y: 50, opacity: 0 },
//         visible: { y: 0, opacity: 1, transition: { type: 'spring', stiffness: 100, damping: 15 } }
//     };

//     const rightItemVariants = {
//         hidden: { y: 50, opacity: 0 },
//         visible: { y: 0, opacity: 1, transition: { type: 'spring', stiffness: 100, damping: 15, delay: 0.1 } }
//     };

//     return (
//         <SectionContainer>
//             {/* Background Decorative Elements */}
//             <div className="absolute inset-0 overflow-hidden pointer-events-none">
//                 <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-blue-600/10 rounded-full blur-[120px]" />
//                 <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cyan-600/10 rounded-full blur-[120px]" />
//             </div>

//             <div className="container mx-auto px-6 relative z-10">

//                 {/* --- HEADER --- */}
//                 <div className="text-center mb-20 max-w-3xl mx-auto">
//                     <motion.div
//                         initial={{ opacity: 0, y: -20 }}
//                         whileInView={{ opacity: 1, y: 0 }}
//                         className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 text-xs font-bold tracking-widest uppercase mb-6"
//                     >
//                         <Zap size={12} fill="currentColor" /> The Paradigm Shift
//                     </motion.div>
//                     <motion.h2 
//                         initial={{ opacity: 0, y: 20 }}
//                         whileInView={{ opacity: 1, y: 0 }}
//                         className="text-3xl md:text-5xl font-bold text-white syne leading-tight mb-6"
//                     >
//                         Strategic <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cyan-400 italic">Evolution</span>
//                     </motion.h2>
//                     <motion.p
//                         initial={{ opacity: 0, y: 20 }}
//                         whileInView={{ opacity: 1, y: 0 }}
//                         transition={{ delay: 0.2, duration: 0.6 }}
//                         className="text-slate-400 text-sm md:text-lg leading-relaxed max-w-2xl mx-auto"
//                     >
//                         Empowering organizations to adapt, innovate, and thrive in a changing business landscape through forward-thinking strategies, workforce transformation, and continuous improvement initiatives.
//                     </motion.p>
//                 </div>

//                 {/* --- DESKTOP EVOLUTION VIEW --- */}
//                 <div className="hidden lg:block max-w-5xl mx-auto">
//                     <div className="relative">
//                         {/* Central Animated Beam */}
//                         <div className="absolute left-1/2 top-0 bottom-0 w-[2px] -translate-x-1/2 overflow-hidden">
//                             <div className="h-full w-full bg-gradient-to-b from-transparent via-blue-500/20 to-transparent" />
//                             <motion.div 
//                                 animate={{ y: ["-100%", "100%"] }}
//                                 transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
//                                 className="absolute top-0 left-0 w-full h-40 bg-gradient-to-b from-transparent via-cyan-400 to-transparent"
//                             />
//                         </div>

//                         {comparisonData.map((item, i) => (
//                             <motion.div 
//                                 key={i} 
//                                 className="grid grid-cols-[1fr_100px_1fr] items-center mb-6 relative"
//                                 onMouseEnter={() => setHoveredIndex(i)}
//                                 onMouseLeave={() => setHoveredIndex(null)}
//                                 initial="hidden"
//                                 whileInView="visible"
//                                 viewport={{ once: true, margin: "-80px" }}
//                             >
//                                 {/* Left Side: Traditional */}
//                                 <motion.div 
//                                     variants={leftItemVariants}
//                                     className={`flex justify-end transition-all duration-500 ${
//                                         hoveredIndex !== null && hoveredIndex !== i ? 'opacity-20 blur-[1px]' : 'opacity-100'
//                                     }`}
//                                 >
//                                     <div className={`
//                                         relative group px-6 py-4 rounded-2xl border transition-all duration-300 w-full max-w-sm text-right
//                                         ${hoveredIndex === i ? 'bg-slate-900/40 border-slate-700' : 'bg-transparent border-white/5'}
//                                     `}>
//                                         <span className="text-slate-500 text-xs font-mono mb-1 block uppercase tracking-tighter">Legacy Model</span>
//                                         <p className="text-slate-300 font-medium">{item.trad}</p>
//                                     </div>
//                                 </motion.div>

//                                 {/* Middle Node */}
//                                 <div className="flex justify-center relative z-20">
//                                     <motion.div 
//                                         animate={{ 
//                                             scale: hoveredIndex === i ? 1.2 : 1,
//                                             backgroundColor: hoveredIndex === i ? '#22d3ee' : '#1e293b'
//                                         }}
//                                         className="w-4 h-4 rounded-full border-4 border-[#01014C] shadow-[0_0_15px_rgba(34,211,238,0.5)]"
//                                     />
//                                     {hoveredIndex === i && (
//                                         <motion.div 
//                                             layoutId="active-glow"
//                                             className="absolute w-12 h-12 bg-cyan-500/20 rounded-full blur-xl"
//                                         />
//                                     )}
//                                 </div>

//                                 {/* Right Side: Merida */}
//                                 <motion.div 
//                                     variants={rightItemVariants}
//                                     className={`flex justify-start transition-all duration-500 ${
//                                         hoveredIndex !== null && hoveredIndex !== i ? 'opacity-20 blur-[1px]' : 'opacity-100'
//                                     }`}
//                                 >
//                                     <div className={`
//                                         relative overflow-hidden px-6 py-4 rounded-2xl border transition-all duration-500 w-full max-w-sm
//                                         ${hoveredIndex === i 
//                                             ? 'bg-gradient-to-r from-blue-600 to-cyan-600 border-cyan-400 shadow-[0_10px_30px_rgba(6,182,212,0.3)] scale-105 z-30' 
//                                             : 'bg-blue-900/20 border-blue-500/30'}
//                                     `}>
//                                         <span className={`text-xs font-bold mb-1 block uppercase tracking-widest ${hoveredIndex === i ? 'text-white/80' : 'text-cyan-400'}`}>
//                                             Merida Advantage
//                                         </span>
//                                         <p className={`font-bold text-lg leading-tight ${hoveredIndex === i ? 'text-white' : 'text-slate-100'}`}>
//                                             {item.merida}
//                                         </p>

//                                         {/* Animated Shimmer for active state */}
//                                         <AnimatePresence>
//                                             {hoveredIndex === i && (
//                                                 <motion.div 
//                                                     initial={{ x: '-100%' }}
//                                                     animate={{ x: '100%' }}
//                                                     exit={{ opacity: 0 }}
//                                                     transition={{ duration: 1, repeat: Infinity, ease: "linear" }}
//                                                     className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent"
//                                                 />
//                                             )}
//                                         </AnimatePresence>
//                                     </div>
//                                 </motion.div>
//                             </motion.div>
//                         ))}
//                     </div>
//                 </div>

//                 {/* --- RESPONSIVE MOBILE VIEW --- */}
//                 <div className="block lg:hidden space-y-4">
//                     {comparisonData.map((item, i) => (
//                         <motion.div 
//                             key={i}
//                             initial={{ opacity: 0, y: 30 }}
//                             whileInView={{ opacity: 1, y: 0 }}
//                             viewport={{ once: true }}
//                             className="bg-[#02023b] border border-blue-900/40 p-5 rounded-2xl relative overflow-hidden"
//                         >
//                             <div className="flex items-center gap-2 mb-3">
//                                 <History size={14} className="text-slate-500" />
//                                 <p className="text-xs text-slate-400 italic">{item.trad}</p>
//                             </div>
//                             <div className="flex items-center gap-3 pt-3 border-t border-white/5">
//                                 <div className="bg-cyan-500 p-1 rounded-md">
//                                     <ArrowRight size={14} className="text-[#01014C]" />
//                                 </div>
//                                 <p className="text-sm font-bold text-white uppercase tracking-tight">{item.merida}</p>
//                             </div>
//                         </motion.div>
//                     ))}
//                 </div>

//             </div>
//         </SectionContainer>
//     );
// };

// const SectionContainer = styled.section`
//     background-color: #01014C;
//     padding: 120px 0;
//     overflow: hidden;
//     position: relative;

//     .syne {
//         font-family: 'Syne', sans-serif;
//     }
// `;

// export default DifferenceSection;




import React from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import CTAButton from '../CTAButton';

const meridaData = [
    { text: "Workforce transformation consulting", color: "bg-blue-600 text-white border-blue-500", x: "10%", y: "80%", r: -5 },
    { text: "Strategic talent alignment", color: "bg-slate-900 text-white border-slate-800", x: "45%", y: "73%", r: 8 },
    { text: "Industry-specialized workforce expertise", color: "bg-cyan-500 text-white border-cyan-400", x: "15%", y: "64%", r: -12 },
    { text: "Integrated workforce ecosystem", color: "bg-blue-500 text-white border-blue-400", x: "50%", y: "55%", r: 4 },
    { text: "AI-assisted recruitment operations", color: "bg-slate-800 text-white border-slate-700", x: "12%", y: "46%", r: 6 },
    { text: "Long-term workforce scalability", color: "bg-blue-700 text-white border-blue-600", x: "52%", y: "38%", r: -3 },
    { text: "Operational workforce consulting", color: "bg-cyan-600 text-white border-cyan-500", x: "20%", y: "30%", r: 10 },
    { text: "Structured workforce systems", color: "bg-slate-900 text-white border-slate-800", x: "48%", y: "21%", r: -7 },
    { text: "Workforce intelligence & planning", color: "bg-blue-600 text-white border-blue-500", x: "15%", y: "12%", r: -5 },
];

const tradData = [
    { text: "Vacancy-focused hiring", x: "15%", y: "82%", r: 10, color: "bg-slate-700 text-slate-100 border-slate-600" },
    { text: "Resume-forward sourcing", x: "50%", y: "76%", r: -8, color: "bg-slate-600 text-slate-200 border-slate-500" },
    { text: "Generic recruitment support", x: "10%", y: "67%", r: 5, color: "bg-zinc-700 text-slate-100 border-zinc-600" },
    { text: "Fragmented HR services", x: "55%", y: "59%", r: -15, color: "bg-neutral-800 text-neutral-100 border-neutral-700" },
    { text: "Manual recruitment execution", x: "20%", y: "51%", r: 12, color: "bg-slate-800 text-slate-200 border-slate-700" },
    { text: "Short-term staffing support", x: "48%", y: "42%", r: -6, color: "bg-slate-700 text-slate-100 border-slate-600" },
    { text: "Hiring-focused engagement", x: "15%", y: "33%", r: 18, color: "bg-zinc-800 text-slate-100 border-zinc-700" },
    { text: "Reactive HR processes", x: "55%", y: "24%", r: -5, color: "bg-neutral-700 text-slate-200 border-neutral-600" },
    { text: "Limited visibility", x: "25%", y: "15%", r: 10, color: "bg-slate-600 text-slate-100 border-slate-500" },
];

const containerVariants = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.15
        }
    }
};

const tradContainerVariants = {
    hidden: {},
    visible: {
        transition: {
            staggerChildren: 0.15,
            delayChildren: 0.5
        }
    }
};

const pillVariants = {
    hidden: { y: -500, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            type: "spring",
            stiffness: 60,
            damping: 15
        }
    }
};

const tradPillVariants = {
    hidden: { y: -500, opacity: 0 },
    visible: {
        y: 0,
        opacity: 1,
        transition: {
            type: "spring",
            stiffness: 40,
            damping: 20
        }
    }
};

const DifferenceSection = () => {
    const navigate = useNavigate();
    return (
        <SectionContainer>
            <div className="container mx-auto px-6 relative z-10">
                {/* --- HEADER --- */}
                <div className="text-center mb-16">
                    <motion.h2
                        initial={{ opacity: 0, y: 10 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        className="text-3xl md:text-5xl font-bold text-slate-900 mb-4 tracking-tight syne"
                    >
                        Why <span className="text-blue-600">Merida</span>
                    </motion.h2>
                    <p className="text-slate-500 text-sm md:text-lg">
                        Transforming organizational DNA through strategic intelligence.
                    </p>
                </div>

                {/* --- BOXES --- */}
                <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">

                    {/* MERIDA SIDE */}
                    <div className="flex flex-col items-center">
                        <div className="mb-6">
                            <LabelTag className="bg-blue-50 text-blue-600 border-blue-100">
                                THE MERIDA WAY
                            </LabelTag>
                        </div>
                        <DropZone className="border-slate-800 bg-white shadow-[0_20px_50px_rgba(0,0,0,0.05)]">
                            <motion.div
                                variants={containerVariants}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: false, amount: 0.1 }}
                                className="w-full h-full relative"
                            >
                                {meridaData.map((item, i) => (
                                    <motion.div
                                        key={`merida-${i}`}
                                        variants={pillVariants}
                                        style={{
                                            position: 'absolute',
                                            left: item.x,
                                            top: item.y,
                                            rotate: `${item.r}deg`
                                        }}
                                        className={`px-3 py-1 md:px-3.5 md:py-1 rounded-full shadow-lg font-bold text-[11px] md:text-[13px] whitespace-nowrap cursor-default border border-transparent ${item.color}`}
                                    >
                                        {item.text}
                                    </motion.div>
                                ))}
                            </motion.div>
                        </DropZone>
                    </div>

                    {/* TRADITIONAL SIDE */}
                    <div className="flex flex-col items-center">
                        <div className="mb-6">
                            <LabelTag className="bg-slate-50 text-slate-400 border-slate-200">
                                TRADITIONAL WAY
                            </LabelTag>
                        </div>
                        <DropZone className="border-slate-800 bg-white">
                            <motion.div
                                variants={tradContainerVariants}
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: false, amount: 0.1 }}
                                className="w-full h-full relative"
                            >
                                {tradData.map((item, i) => (
                                    <motion.div
                                        key={`trad-${i}`}
                                        variants={tradPillVariants}
                                        style={{
                                            position: 'absolute',
                                            left: item.x,
                                            top: item.y,
                                            rotate: `${item.r}deg`
                                        }}
                                        className={`px-3 py-1 md:px-3.5 md:py-1 rounded-full border font-bold text-[11px] md:text-[13px] whitespace-nowrap shadow-md cursor-default ${item.color}`}
                                    >
                                        {item.text}
                                    </motion.div>
                                ))}
                            </motion.div>
                        </DropZone>
                    </div>

                </div>

                <div className="flex justify-center mt-12 relative z-20">
                    <CTAButton 
                        text="Explore Workforce Solutions"
                        onClick={() => navigate('/contact')}
                        type="secondary"
                    />
                </div>
            </div>

            {/* Grid Background */}
            <div className="absolute inset-0 z-0 opacity-[0.04] pointer-events-none"
                style={{ backgroundImage: `radial-gradient(#000 1.5px, transparent 1.5px)`, backgroundSize: '30px 30px' }}
            />
        </SectionContainer>
    );
};

const SectionContainer = styled.section`
    background-color: #e2effe;
    padding: 60px 0 80px;
    position: relative;
    overflow: hidden;
`;

const LabelTag = styled.span`
    padding: 8px 32px;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 800;
    letter-spacing: 0.15em;
    border: 1px solid;
    display: inline-block;
`;

const DropZone = styled.div`
    height: 550px;
    width: 100%;
    min-width: 450px;
    border-radius: 4rem;
    position: relative;
    border: 1.5px solid #111;
    overflow: hidden; /* This keeps them inside the "bottle" */
    
    @media (max-width: 768px) {
        min-width: 100%;
        height: 450px;
    }
`;

export default DifferenceSection;